import { supabase } from '../supabaseClient';

export const notifyTransactionChange = async (record, oldRecord = {}) => {
  if (!record?.user_id) return { skipped: true, reason: 'missing_user_id' };

  const { data, error } = await supabase.functions.invoke('smooth-function', {
    body: {
      record,
      old_record: oldRecord,
    },
  });

  if (error) {
    console.error('Error al invocar smooth-function:', error);
    return { sent: false, error };
  }

  if (data?.sent === false) {
    console.warn('smooth-function no envió notificación:', data?.reason || data);
  }

  return data;
};
